<template>
    <div class="sliderContent">
        <h2>{{dataSlider.title}}</h2>
        <p>{{dataSlider.longText}}</p>
        <div class="user_slider_wrpapper">
            <imgCompifilerComponent :url="dataSlider.userImg" />
            <div>
                <h6>{{dataSlider.userName}}</h6>
                <strong>{{dataSlider.userCompany}}</strong>
            </div>
        </div>
    </div>
</template>

<script>
    import imgCompifilerComponent from "./ImgCompnent.vue";
    export default {
        name: "SliderComponent",
        props: ['dataSlider'],
        components: {
            imgCompifilerComponent
        }
    }
</script>

<style lang="scss" scoped>
    .sliderContent {
        width: 700px;
        margin: 0 auto;
        padding: 20px;
        margin-top: 38px;
        h2 {
            padding-top: 18px;
            font-size: 40px;
            color: #217a73;
            letter-spacing: 0.3px;
            font-family: 'HelveticaNeueCyr';
            font-weight: bold;
            text-align: center;
            font-weight: 500;
            margin-left: 14px;
        }

        p {
            padding-top: 49px;
            width: 732px;
            color: #7d7d7d;
            font-size: 24px;
            text-align: center;
            line-height: 40px;
            margin: 0 auto;
            margin-left: -0.5px;
            position: relative;
        }

        p:after {
            content: "";
            background-image: url("../assets/images/vergul_icon.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -17.1%;
            top: 6px;
            height: 210px;
            width: 115px;
        }

        p:before {
            content: "";
            background-image: url("../assets/images/vergul_icon.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            height: 210px;
            width: 115px;
            right: -78px;
            bottom: -69px;
            transform: rotate(180deg);
        }
    }

    .user_slider_wrpapper {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-top: 34px;
        padding-bottom: 0px;
        margin-left: -18px;
        img {
            width: 80px;
            height: 80px;
        }

        div {
            margin-left: 20px;
            margin-bottom: 50px;
            margin-top: 8px;

            h6 {
                text-align: left;
                margin: 10px 0px;
                margin-bottom: 8px;
                color: #49d6cb !important;
                font-size: 16px;
                font-weight: 500;
            }

            strong {
                font-size: 16px;
                font-weight: 500;
            }
        }
    }

    @media only screen and (max-width: 1750px) {
        .sliderContent {
            width: 700px;
            margin: 0 auto;
            padding: 20px;

            h2 {
                padding-top: 20px;
                font-size: 40px;
                color: #217a73;
                text-align: center;
                font-weight: 400;
            }

            p {
                padding-top: 40px;
                max-width: 640px;
                color: #7d7d7d;
                font-size: 24px;
                text-align: center;
                margin: 0 auto;
                position: relative;
            }

            p:after {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                left: -15%;
                top: -20px;
                height: 200px;
                width: 100px;
            }

            p:before {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                height: 200px;
                width: 100px;
                right: -80px;
                bottom: -60px;
                transform: rotate(180deg);
            }
        }

        .user_slider_wrpapper {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            margin-top: 40px;
            padding-bottom: 40px;

            img {
                width: 60px;
                height: 60px;
            }

            div {
                margin-left: 20px;
                margin-bottom: 50px;
                margin-top: 8px;

                h6 {
                    text-align: left;
                    margin: 5px 0px;
                    color: #49d6cb !important;
                    font-size: 16px;
                    font-weight: 500;
                }

                strong {
                    font-size: 16px;
                    font-weight: 500;
                }
            }
        }
    }

    @media only screen and (max-width: 770px) {
        .sliderContent {
            width: 600px;
            margin: 0 auto;
            padding: 20px;

            h2 {
                padding-top: 20px;
                font-size: 30px;
                color: #217a73;
                text-align: center;
                font-weight: 400;
            }

            p {
                padding-top: 20px;
                max-width: 500px;
                color: #7d7d7d;
                font-size: 20px;
                text-align: center;
                margin: 0 auto;
                position: relative;
                line-height: 1.2;
            }

            p:after {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                left: -10%;
                top: -20px;
                height: 150px;
                width: 50px;
            }

            p:before {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                height: 150px;
                width: 50px;
                right: -60px;
                bottom: -30px;
                transform: rotate(180deg);
            }
        }

        .user_slider_wrpapper {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            margin-top: 40px;
            padding-bottom: 0px;

            img {
                width: 60px;
                height: 60px;
            }

            div {
                margin-left: 20px;
                margin-bottom: 50px;
                margin-top: 8px;

                h6 {
                    text-align: left;
                    margin: 5px 0px;
                    color: #49d6cb !important;
                    font-size: 16px;
                    font-weight: 500;
                }

                strong {
                    font-size: 16px;
                    font-weight: 500;
                }
            }
        }
    }
@media only screen and (max-width: 645px) {
        .sliderContent {
            width: 100%;
            margin: 0 auto;
            padding: 10px;
            h2 {
                padding-top: 20px;
                font-size: 25px;
                color: #217a73;
                text-align: center;
                font-weight: 400;
            }

            p {
                padding-top: 20px;
                max-width: 350px;
                color: #7d7d7d;
                font-size: 15px;
                text-align: center;
                margin: 0 auto;
                position: relative;
                line-height: 1.4;
            }

            p:after {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                left: -15%;
                top: -10px;
                height: 150px;
                width: 50px;
            }

            p:before {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                height: 140px;
                width: 45px;
                right: -40px;
                bottom: -20px;
                transform: rotate(180deg);
            }
        }

        .user_slider_wrpapper {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            margin-top: 40px;
            padding-bottom: 0px;

            img {
                width: 50px;
                height: 50px;
            }

            div {
                margin-left: 10px;
                margin-bottom: 50px;
                margin-top: 2px;

                h6 {
                    text-align: left;
                    margin: 5px 0px;
                    color: #49d6cb !important;
                    font-size: 14px;
                    font-weight: 500;
                }

                strong {
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
    }
    @media only screen and (max-width: 450px) {
        .sliderContent {
            width: 300px;
            margin: 0 auto;
            padding: 0px;

            h2 {
                padding-top: 45px;
                font-size: 25px;
                color: #217a73;
                text-align: center;
                font-weight: 400;
            }

            p {
                padding-top: 20px;
                max-width: 300px;
                color: #7d7d7d;
                font-size: 12px;
                text-align: center;
                margin: 0 auto;
                position: relative;
                line-height: 1.3;
            }

            p:after {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                left: -10%;
                top: -0px;
                height: 100px;
                width: 30px;
            }

            p:before {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                height: 150px;
                width: 30px;
                right: -30px;
                bottom: -0px;
                transform: rotate(180deg);
            }
        }

        .user_slider_wrpapper {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            margin-top: 30px;
            padding-bottom: 0px;

            img {
                width: 50px;
                height: 50px;
            }

            div {
                margin-left: 20px;
                margin-bottom: 20px;
                margin-top: 2px;

                h6 {
                    text-align: left;
                    margin: 2px 0px;
                    color: #49d6cb !important;
                    font-size: 14px;
                    font-weight: 500;
                }

                strong {
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
    }
     @media only screen and (max-width: 350px) {
        .sliderContent {
            width: 90%;
            margin: 0 auto;
            padding: 0px;

            h2 {
                padding-top: 35px;
                font-size: 20px;
                color: #217a73;
                text-align: center;
                font-weight: 400;
            }
            p {
                padding-top: 20px;
                max-width: 90%;
                color: #7d7d7d;
                font-size: 10px;
                text-align: center;
                margin: 0 auto;
                position: relative;
                line-height: 1.3;
            }

            p:after {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                left: -3%;
                top: 10px;
                height: 80px;
                width: 20px;
            }

            p:before {
                content: "";
                background-image: url("../assets/images/vergul_icon.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                height: 20px;
                width: 20px;
                right: -15px;
                bottom: -10px;
                transform: rotate(180deg);
            }
        }

        .user_slider_wrpapper {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            margin-top: 30px;
            padding-bottom: 0px;

            img {
                width: 50px;
                height: 50px;
            }

            div {
                margin-left: 20px;
                margin-bottom: 20px;
                margin-top: 2px;

                h6 {
                    text-align: left;
                    margin: 2px 0px;
                    color: #49d6cb !important;
                    font-size: 14px;
                    font-weight: 500;
                }

                strong {
                    font-size: 14px;
                    font-weight: 500;
                }
            }
        }
    }
</style>